import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import {
  BlogModel,
  CommonCategoryModel,
  PaginationModel,
  RequestParamModel,
} from '@coreModels';
import { ApiConstants } from '@coreConstant';
import { catchError, map, throwError } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { ToastService } from '../toast.service';

@Injectable({
  providedIn: 'root',
})
export class BlogService {
  constructor(
    private baseService: BaseService,
    private toastService: ToastService
  ) {}

  /**
   *  Get all blog list
   * @param requestParamModel
   * @returns
   */
  getBlog(requestParamModel?: RequestParamModel) {
    return this.baseService
      .get(ApiConstants.BLOG_LIST_URL, requestParamModel)
      .pipe(
        map((response: HttpResponse<any>) => {
          const blogList = new PaginationModel<BlogModel>();
          const headers = response.headers;
          blogList.setHeaders(headers);
          blogList.data = response.body.data as BlogModel[];
          return blogList;
        }),
        catchError((error: any) => {
          this.toastService.showError(error);
          return throwError(() => new Error('Failed to fetch blog data'));
        })
      );
  }

  /**
   * Get Category of blog
   * @param requestParamModel
   * @returns
   */
  getCategoryList(requestParamModel?: RequestParamModel) {
    return this.baseService
      .get(ApiConstants.BLOG_CATEGORY_LIST_URL, requestParamModel)
      .pipe(
        map((response: HttpResponse<any>) => {
          const blogCategoryList = new PaginationModel<CommonCategoryModel>();
          const headers = response.headers;
          blogCategoryList.setHeaders(headers);
          blogCategoryList.data = response.body.data as CommonCategoryModel[];
          return blogCategoryList;
        }),
        catchError((error: any) => {
          this.toastService.showError(error);
          return throwError(() => new Error('Failed to fetch blog data'));
        })
      );
  }

  /**
   *
   * @param id Get blog details o their Ids
   * @param requestParamModel
   * @returns
   */
  getBlogById(id: any, requestParamModel: any) {
    return this.baseService
      .get(`${ApiConstants.BLOG_DETAIL_URL}${id}`, requestParamModel)
      .pipe(
        map<any, any>((response: HttpResponse<any>) => {
          return response.body;
        }),
        catchError((error: any) => {
          this.toastService.showError(error);
          return throwError(() => new Error('Failed to fetch blog data'));
        })
      );
  }
}
